import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
export default class RequestScenario extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'scenarios-getScenarioV3',
      payload: {
        scenario_id: this._payload.scenario_id,
        is_staging: this._payload.is_staging || false,
      },
    });
  }

  onSuccess(data) {
    super.onSuccess(data);
    // Send scenario download requested event
    this._dispatch({
      type: Actions.AppActions.AnalyticsEvent,
      payload: {
        type: AnalyticsEvents.scenario_downloaded,
        data: data
      }
    })
  }
}